import React from 'react';
import { Card } from '@doveit/bricks';
import { AgentArea } from '../../providers/api/dtos/agentArea';
import Table, { DEFAULT_TABLE_PAGE_SIZE } from '../table/Table';
import areasTableColumns from './columnsSettings';

export interface AreasTableProps extends React.AriaAttributes {
  data: AgentArea[],
}

const AreasTable: React.FC<AreasTableProps> = ({
  data,
  ...rest
}) => (
  <Card>
    <Card.Content>
      <Table
        {...rest}
        data={data}
        columns={areasTableColumns}
        pageable={data.length > DEFAULT_TABLE_PAGE_SIZE}
        sortable
        filterable
      />
    </Card.Content>
  </Card>
);

export default AreasTable;
